<template>
  <div>
    <div class="markup__h markup__h_2"><strong>Основные поддерживаемые размеры баннеров:</strong></div>
    <ul class="markup__ul markup__ul_nested">
      <li><strong>Desktop Web:</strong> 300x250, 300x300, 240x400, 728x90, 970x250, 300x600</li>
      <li><strong>Mobile Web:</strong> 300x250, 320x50, 320x100, 336x280, 320х480, 300x300, 300x50</li>
    </ul>
    <br />

    <div class="markup__h markup__h_2"><strong>Есть четыре варианта:</strong></div>
    <ul class="markup__ul markup__ul_clear">
      <li>
        <div class="markup__h markup__h_3">
          <strong>1. Креатив собирается на платформах Weborama или Sizmek:</strong>
          <div class="markup__ul-description">С обеими платформами Buzzoola имеет автоматическую интеграцию, поэтому при
            сборке баннера через них достаточно:</div>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>
            <div class="markup__h markup__h_4">
              Для платформы <strong>Weborama:</strong> сообщить, что размещение кода планируется в Buzzoola, и в
              зависимости от формата исходных материалов (изображения или html-код), они смогут подобрать нужный шаблон.
            </div>
          </li>
          <li>
            <div class="markup__h markup__h_4">
              Для платформы <strong>Sizmek:</strong> сообщить, что планируется полноэкранное размещение (fullscreen).
            </div>
          </li>
        </ul>
        <br>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>2. Креатив собирает продакшен клиента:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>
            <div class="markup__h markup__h_4">
              В качестве креатива должен быть предоставлен валидный <strong>адаптивный по высоте и ширине</strong>
              HTML-код или ссылка на него
            </div>
          </li>
          <li>
            <div class="markup__h markup__h_4">
              Для трекинга событий на нашей стороне <strong>клиенту необходимо</strong> внутри баннера:
            </div>
            <ul class="markup__ul markup__ul_nested">
              <li>загружать скрипт <strong>https://tube.buzzoola.com/js/lib/banner.js</strong></li>
              <li>
                вызывать метод <strong>buzzTrack() / window.buzzTrack()</strong> и передавать туда строковые имена
                событий (см. пример ниже):
                <ul class="markup__ul markup__ul_nested">
                  <li><strong>loaded</strong> - после успешной загрузки баннера</li>
                  <li><strong>click</strong> - при совершении перехода</li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <div class="markup__h markup__h_4">
              При передаче креатива должны быть оговорены размеры креатива: фиксированные или адаптивные. Если
              фиксированные, то какие конкретно (например, 300х250, 240x400, 728х90, 300х600 или другой размер).
            </div>
          </li>
          <li>
            <div class="markup__h markup__h_4">
              Фон баннера не должен быть прозрачным. При наличии однородного светлого фона необходима черная рамка 1px
            </div>
          </li>
          <li>
            <div class="markup__h markup__h_4">
              При наведении на баннер курсор мыши должен меняться на pointer
            </div>
          </li>
          <li>
            <div class="markup__h markup__h_4">
              Необходимо нанести на баннер кнопку Call-To-Action
            </div>
          </li>
        </ul>
        <div class="markup__h markup__h_4 markup__h_orange">
          <strong>Пример кода адаптивного баннера с трекингом и подключенной библиотекой:</strong>
        </div>
        <banner-example-adaptive></banner-example-adaptive>

        <div class="html2pdf__page-break" />
        <br>

        <div class="markup__h markup__h_4 markup__h_orange">
          <strong>Пример кода баннера с фиксированными размерами, трекингом и подключенной библиотекой:</strong>
        </div>
        <banner-example-fixed></banner-example-fixed>
        <br>
      </li>
      <li>
        <div class="markup__h markup__h_3"><strong>3. Креатив собирается на стороне Buzzoola:</strong></div>
        <ul class="markup__ul markup__ul_nested">
          <li>Формат: PSD / FIGMA / AI</li>
          <li>Должны быть оговорены размеры креатива: фиксированные или адаптивные. Если фиксированные, то какие
            конкретно (например, 300х250, 240x400, 728х90, 300х600 или другой размер). Для адаптивного баннера ширина
            макетов от 1000px.</li>
          <li>Кликовые ссылки: прямая с utm-разметкой или клик-трекер</li>
          <li>
            <div class="markup__h markup__h_4">Опционально:</div>
            <ul class="markup__ul markup__ul_nested">
              <li>Пиксель-трекеры на другие события</li>
              <li>Сценарий (последовательность анимации, смены слайдов и т.д.)</li>
              <li>Описание интерактивных элементов (кликабельные элементы, кнопки и т.д.)</li>
              <li>При отсутствии макетов для сборки креатива необходимо предоставить тексты и изображения, логотип,
                фирменные шрифты, Brandbook (в том числе пожелания по цветовому оформлению)</li>
            </ul>
          </li>
        </ul>
        <div class="html2pdf__page-break" />
        <br>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>4. Размещение изображением:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Формат файла: PNG, JPG, GIF</li>
          <li>Должны быть оговорены размеры креатива: фиксированные или адаптивные. Если фиксированные, то какие
            конкретно (например, 300х250, 240x400, 728х90, 300х600 или другой размер). Для адаптивного баннера ширина
            картинки от 1000px.</li>
        </ul>
      </li>
    </ul>
    <marked-zone-atention></marked-zone-atention>
  </div>

</template>

<script>
import markedZoneAtention from '@/components/documentation/markedZoneAtention.vue';
import bannerExampleAdaptive from '@/components/documentation/bannerExampleAdaptive.vue';
import bannerExampleFixed from '@/components/documentation/bannerExampleFixed.vue';

export default {
  name: 'bannersArticle',
  components: {
    markedZoneAtention,
    bannerExampleAdaptive,
    bannerExampleFixed,
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang='stylus'>
@import '../../styles/main.styl'
@import '../../styles/documentation_article_markup.styl'

</style>
